import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=934bd91c&scoped=true"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"
import style0 from "./payments.vue?vue&type=style&index=0&id=934bd91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934bd91c",
  null
  
)

export default component.exports